module.exports = __webpack_public_path__ + "img/sitemap-clouds-2.d3affb07.png";